import { registerPlugin } from '@capacitor/core';

import type { LunaSDKPlugin } from './definitions';

const LunaSDK = registerPlugin<LunaSDKPlugin>('LunaSDK', {
  web: () => import('./web').then(m => new m.LunaSDKWeb()),
});

export * from './definitions';
export { LunaSDK };
